import { EventType, sendBeacon } from './module/beacon';

/**
 * just for recording article page view here
 */

// trigger analytics page view
const page = new URL(location.href);
let pageId;
let host = page.host;
let href = page.href;

const parsePageId = (pathname: string) => {
  const paths = pathname.split('-');
  const id = paths[paths.length - 1];
  if (/\d/.test(id)) {
    return id.replace(/\.html$/, '');
  }
  return null;
};

const pageOriginUrl = window._pixels?.pageOriginUrl || page.searchParams.get('pageOriginUrl');
let platform = 'native';

if (window._pixels?.platform) {
  platform = window._pixels?.platform;
} else if (page.searchParams.get('platform')) {
  platform = page.searchParams.get('platform');
}
if (pageOriginUrl) {
  // detect if the page is amp placeholder page or FBIA
  const { pathname, host: originHost, href: originHREF } = new URL(pageOriginUrl);
  pageId = parsePageId(pathname);
  href = originHREF;
  host = originHost;
} else {
  // make sure it's valid article page
  pageId = parsePageId(page.pathname);
}

if (pageId) {
  sendBeacon({
    id: pageId,
    href,
    host,
    eventType: EventType.PAGE_VIEW,
    platform,
  });
}
